module.exports = __webpack_public_path__ + "static/media/MCT-Slider-mobile-2.a9b1d3c0.jpg";